import type ISection from "./Section";export const sections: ISection[] = [
  {
    name: "Guy-wires",
    drillholes: [
      {id: "h", symbol: "h", hasIndex: false},
      {id: "j", symbol: "j", hasIndex: false},
    ],
  },
  {
    name: "Groundcable",
    drillholes: [{id: "e", symbol: "e", hasIndex: true}],
  },
  {
    name: "Anchoring",
    drillholes: [
      {id: "v_0", symbol: "v", hasIndex: true},
      {id: "v_1", symbol: "v", hasIndex: true},
      {id: "v_2", symbol: "v", hasIndex: true},
      {id: "pa", symbol: "pa", hasIndex: false},
    ],
  },
  {
    name: "Other",
    drillholes: [
      {id: "r", symbol: "r", hasIndex: true},
      {id: "l", symbol: "l", hasIndex: false},
      {id: "o_noindex", symbol: "o", hasIndex: false},
      {id: "o_indexed", symbol: "o", hasIndex: true},
    ],
  },
  {
    name: "DTW",
    drillholes: [{id: "dtw", symbol: "dtw", hasIndex: false}],
  },
  {
    name: "Ground",
    drillholes: [{id: "s", symbol: "s", hasIndex: true}],
  },
  {
    name: "Feeder console",
    drillholes: [{id: "lf", symbol: "lf", hasIndex: false}],
  },
  {
    name: "Portal",
    drillholes: [
      {id: "n", symbol: "n", hasIndex: true},
      {id: "a", symbol: "a", hasIndex: false},
    ],
  },
];